/**
 * The rule that separates watching a lesson from scrubbing through it.
 *
 * Kept apart from the player it serves, and free of the DOM, so the tests can reach it: the
 * repository type-checks test files against a Node-only config, and a module touching window or
 * HTMLIFrameElement drags that whole world in behind it. The same reason slug.ts lives here.
 */

/** How often the player is asked where it is. Cheap — a property read, no network. */
export const SAMPLE_MS = 1_000;

/** How often that is worth telling the server. A lesson does not need per-second fidelity. */
export const REPORT_MS = 15_000;

/**
 * Whether a step forward between two samples was somebody watching.
 *
 * The whole honesty of the count lives here. Dragging the scrubber to the end puts the position
 * at the end while nothing was watched, and a lesson that accepts that teaches children to drag
 * the scrubber. So only a step of about one sampling interval counts: playing forwards, at
 * something like a normal speed. The ceiling is generous enough for double speed, which is a real
 * way to watch a lesson, and refuses the leap a seek makes.
 */
export function countsAsWatching(movedSeconds: number, sampleSeconds: number): boolean {
  return movedSeconds > 0 && movedSeconds <= sampleSeconds * 2.5;
}
